import React, { Component } from 'react'
import Checkbox from "Components/Common/checkbox";
import { observer } from "mobx-react";
import 'Styles/commonComponents/FiltersPanel/FilterListLine.scss';

class FilterListLine extends Component {
    render() {
        return (
            <div className={"filter-line " + (this.props.isSelected ? 'selected' : '')}>
                <Checkbox
                    checked={this.props.isSelected}
                    onChange={(checked) => this.props.onSelected(checked)}
                />
                <div className="line-title">
                    {this.props.title}
                </div>
            </div>
        );
    }
};

export default observer(FilterListLine);